<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title>{{'Reports.addReportHeader' | translate}}</h1>
  <div mat-dialog-content>
    <mat-form-field class="col-12">
      <mat-label>{{'Reports.lblReportName' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Reports.lblReportName' | translate}}" [(ngModel)]="reportName" [ngModelOptions]="{standalone: true}" required maxlength="200"/>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OnSaveReport()">{{'btnSave' | translate}}</button>&nbsp;
    <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
  </div>
</form>